import React from "react";
import { useTranslation } from "react-i18next";
import SocialNetworkLinks from "../../components/social-network-links/SocialNetworkLinks";

const Contact = () => {
  const { t } = useTranslation();
  // const [loading, setLoading] = useState(false);

  // const handleSubmit = (e) => {
  //   e.preventDefault();
  //   setLoading(true);

  //   setTimeout(() => {
  //     setLoading(false);
  //   }, 2000);
  // };

  return (
    <div className="container mx-auto px-6 py-12 min-h-screen mt-10 lg:mt-20 text-baseBlue">
      <h1 className="text-4xl font-bold text-center">{t("contactUs")}</h1>
      <div className="grid md:grid-cols-1 gap-8 max-w-3xl mx-auto">
        {/* Contact Form */}
        {/* <div className="p-8 rounded-xl shadow-lg border border-gray-100">
          <h2 className="text-2xl font-bold mb-6">{t("getInTouch")}</h2>
          <form onSubmit={handleSubmit}>
            <div className="mb-6">
              <label className="block text-sm font-medium mb-2">
                {t("name")}
              </label>
              <input
                className="w-full p-3 border rounded-lg focus:outline-none text-baseBlue focus:ring-2 focus:ring-baseGreen"
                type="text"
                placeholder={t("enterYourName")}
                required
              />
            </div>
            <div className="mb-6">
              <label className="block text-sm font-medium mb-2">
                {t("email")}
              </label>
              <input
                className="w-full p-3 border rounded-lg focus:outline-none text-baseBlue focus:ring-2 focus:ring-baseGreen"
                type="email"
                placeholder={t("enterYourEmail")}
                required
              />
            </div>
            <div className="mb-6">
              <label className="block text-sm font-medium mb-2">
                {t("message")}
              </label>
              <textarea
                className="w-full p-3 border rounded-lg focus:outline-none text-baseBlue focus:ring-2 focus:ring-baseGreen"
                rows="4"
                placeholder={t("enterYourMessage")}
                required
              ></textarea>
            </div>

            <TransparentButton
              type="submit"
              text={loading ? t("sending") : t("sendMessage")}
            />
          </form>
        </div> */}

        {/* Contact Information */}
        <div className="p-8 rounded-xl">
          <h2 className="text-2xl font-bold mb-6">{t("contactInformation")}</h2>
          <div className="space-y-4">
            <p>{t("giorgitsminda")}</p>
            <p>{t("SagarejoGeorgia3800")}</p>
            <p>
              {t("email")}:{" "}
              <a
                href="mailto:awcgarejelebi@gmail.com"
                className=" hover:underline"
              >
                awcgarejelebi@gmail.com
              </a>
            </p>
            <div className="flex">
              <div className="pr-2">{t("phone")}: </div>
              <div className="flex flex-col">
                <a href="tel:+995598720440" className=" hover:underline">
                  +995 (598) 720 440
                </a>
                <a href="tel:+995598314917" className=" hover:underline">
                  +995 (598) 314 917
                </a>
              </div>
            </div>
            <SocialNetworkLinks />
          </div>

          {/* Location Map */}
          <h3 className="text-xl font-bold mt-8 mb-4">{t("ourLocation")}</h3>
          <div className="w-full h-64 bg-gray-100 rounded-lg overflow-hidden">
            <iframe
              title="Google Map"
              className="w-full h-full border-none"
              src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d3009.0535121981677!2d45.35476!3d41.732507!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x404421004d12fc7f%3A0x574e979de642de95!2sAwc%20Garejelebi!5e0!3m2!1sen!2sus!4v1690819600518!5m2!1sen!2sus"
              allowFullScreen
            ></iframe>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Contact;
